var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.413.6c4.608 0 8.472 1.152 11.592 3.456 3.168 2.256 5.52 5.304 7.056 9.144 1.584 3.792 2.376 7.992 2.376 12.6 0 4.752-.792 9.024-2.376 12.816-1.536 3.792-3.888 6.816-7.056 9.072C29.885 49.896 26.021 51 21.413 51H3.053c-.624 0-1.152-.192-1.584-.576-.384-.432-.576-.96-.576-1.584V2.76c0-.624.192-1.128.576-1.512C1.901.816 2.429.6 3.053.6h18.36zm-.72 46.152c5.76 0 10.056-1.92 12.888-5.76 2.832-3.888 4.248-8.952 4.248-15.192 0-3.888-.6-7.392-1.8-10.512-1.2-3.168-3.096-5.688-5.688-7.56-2.544-1.92-5.76-2.88-9.648-2.88H5.429v41.904h15.264z",
    fill: "currentColor"
  })));
}
export default SvgD;